import Middleware from './middleware'
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime'

// Active schemes
import { default as Scheme$61fe } from '/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/schemes/auth0.ts'
import { default as Scheme$a1bf } from '/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/schemes/sigil.ts'

Middleware.auth = authMiddleware

export default function (ctx, inject) {
  // Options
  const options = {
  "resetOnError": false,
  "ignoreExceptions": false,
  "scopeKey": "scope",
  "rewriteRedirects": true,
  "fullPathRedirect": false,
  "watchLoggedIn": true,
  "redirect": {
    "login": "/login",
    "logout": "/",
    "home": "/auth",
    "callback": "/auth/callback"
  },
  "vuex": {
    "namespace": "auth"
  },
  "cookie": {
    "prefix": "auth.",
    "options": {
      "path": "/"
    }
  },
  "localStorage": false,
  "defaultStrategy": "auth0"
}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // auth0
  $auth.registerStrategy('auth0', new Scheme$61fe($auth, {
  "token": {
    "property": "accessToken",
    "maxAge": 36000
  },
  "refreshToken": {
    "property": "refreshToken",
    "maxAge": 2592000
  },
  "idToken": {
    "property": "idToken",
    "maxAge": 36000
  },
  "domain": "login.shopltk.com",
  "clientId": "Npc10D73rjuLZjN3GyV2TFZy7aT2OCSG",
  "audience": "https://prod-consumer-api.shopltk.com/v1",
  "scope": [
    "openid",
    "profile",
    "email",
    "ltk.consumer",
    "offline_access"
  ],
  "responseType": "code",
  "grantType": "authorization_code",
  "codeChallengeMethod": "S256",
  "logoutRedirectUri": "https://www.shopltk.com/",
  "name": "auth0",
  "endpoints": {
    "authorization": "https://login.shopltk.com/authorize",
    "userInfo": "https://login.shopltk.com/userinfo",
    "token": "https://login.shopltk.com/oauth/token",
    "logout": "https://login.shopltk.com/v2/logout"
  }
}))

  // sigil
  $auth.registerStrategy('sigil', new Scheme$a1bf($auth, {
  "cookie": {
    "options": {
      "secure": true,
      "maxAge": 31104000
    }
  },
  "token": {
    "property": "accessToken",
    "maxAge": 15552000
  },
  "refreshToken": {
    "property": "refreshToken",
    "maxAge": 31104000
  },
  "idToken": {
    "property": "idToken"
  },
  "user": {
    "property": false
  },
  "clientId": "D9UoqU4ZYUkA21LmFSe6dcHRXgwOxPOHWvcyVQph",
  "grantType": "password",
  "scope": "openid associations email ltk.consumer profile-write",
  "endpoints": {
    "login": {
      "url": "/token/",
      "method": "post",
      "headers": {
        "content-type": "application/x-www-form-urlencoded"
      }
    },
    "refresh": {
      "url": "/token/",
      "method": "post",
      "headers": {
        "content-type": "application/x-www-form-urlencoded"
      }
    },
    "user": {
      "url": "/userinfo/",
      "method": "get"
    },
    "logout": {
      "url": "/logout/",
      "method": "get"
    },
    "signup": {
      "url": "/api/signup/ltk/",
      "method": "post"
    },
    "forgotPassword": {
      "url": "/api/password/request/ltk/",
      "method": "post"
    },
    "changePassword": {
      "url": "/api/users/me/password/",
      "method": "post"
    },
    "changeEmail": {
      "url": "/api/users/me/",
      "method": "put",
      "headers": {
        "content-type": "application/x-www-form-urlencoded"
      }
    }
  },
  "name": "sigil"
}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return
      }

      console.error('[ERROR] [AUTH]', error)
    }
  })
}
